<template>
  <div :class="`col-md-${width} form-group`">
    <label v-if="label" class="control-label">{{ `${label} ${required ? '*' : ''}` }}</label>
    <p v-if="help" class="help-block">{{ help }}</p>

    <div class="radio">
      <label v-for="option in options" :key="option.value">
        <input type="radio" :name="name" :value="option.value" :disabled="disabled" :required="required" :checked="option.value == value" @change="$emit('input', option.value)" />
        {{ option.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '12' },
    placeholder: { type: String, default: '' },
    value: { type: String | Number, default: '' },
    name: { type: String, required: true },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    options: { type: Array, required: true },
    label: String,
    help: String,
  },
};
</script>

<style scoped>
.radio label {
  margin-left: 20px;
}
.radio label:first-child {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/inputs/radio.vue